import { Button as AntButton } from "antd";

const outline =
  "bg-white text-secondary border border-primary hover:!bg-transparent hover:text-primary hover:shadow-md disabled:bg-gray-100 disabled:text-gray-500 disabled:border-gray-300 disabled:cursor-not-allowed";

const solid = "bg-primary text-white hover:text-secondary hover:bg-white";
const primary =
  "!bg-gradient-to-r !from-[#90B393] !to-[#32493B] !border-none !text-white px-5 !py-2 !shadow-[0_4px_12px_#90B39380] hover:!shadow-[0_6px_16px_#90B393B3] hover:!from-[#7FA684] hover:!to-[#27392F]";
const Button = ({ className, onClick, type = "primary", ...props }) => {
  const btnClass =
    type === "solid" ? solid : type === "outline" ? outline : primary;
  return (
    <AntButton
      type={type}
      className={`${btnClass} static transition-[box-shadow] duration-200 ease-in-out font-manropeMedium font-semibold
         hover:shadow-[0_10px_20px_rgba(0,0,0,0.18),_0_6px_6px_rgba(0,0,0,0.22)] ${className}`}
      {...props}
      onClick={onClick}>
      {props.children}
    </AntButton>
  );
};

export default Button;
